<template>
  <div class="card mb-4">
    <div class="card-header pb-0">
      <h6>Projects</h6>
      <p class="text-sm text-secondary mb-0">Project-level test coverage</p>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Project</th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 ps-2">Team</th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Status</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="3" class="text-center text-secondary text-sm py-4">
                Connect data from your API to populate this table.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TestProjectTable",
};
</script>
